module.exports = __webpack_public_path__ + "static/img/1.59e70c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/1.png
// module id = ApTf
// module chunks = 35